import { Component, OnInit, ViewChild } from '@angular/core';
import { NewsModel } from '../../models/NewsModel';
import { ConstantsStore } from '../../core/services/constants.store';
import { NgbCarousel, NgbCarouselConfig, NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NewsStore } from '../../core/services/news/news.store';
import { NewsService } from 'src/app/core/services/news/news.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-carousel-new',
  templateUrl: './carousel-new.component.html',
  styleUrls: ['./carousel-new.component.scss']
})
export class CarouselNewComponent implements OnInit {

  @ViewChild('host', { static: false }) host: NgbCarousel;

  activeSlide: NewsModel;
  subscription: Subscription;

  constructor(
    public store: NewsStore,
    private service: NewsService,
    private router: Router,
    private config: NgbCarouselConfig,
    private constantsStore: ConstantsStore,
  ) {
    config.interval = 5000;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = true;
    config.showNavigationArrows = true;
    config.showNavigationIndicators = true;

    this.getData();
  }

  ngOnInit(): void {
  }

  getNotLoggedNews() {
    return this.store.news.filter(news => news.visibility == 2 || news.visibility == 3);
  }

  getData() {
    this.subscription = this.service.getData()
      .subscribe(
        () => {
          this.store.updateTotalPages();
        },
        err => console.log('Error in GestioneNews: ', err)
      );
  }

  getCompleteImageUrl(news: NewsModel) {
    if (news?.newsRecords[0]?.imagePath) {
      return this.constantsStore.apiUrl + '/' + news.newsRecords[0].imagePath;
    }
  }

  newsTextPreview(news: NewsModel) {
    if (news) {
      const text = news.newsRecords[0].description;
      return (text.length > 160 ? text.substring(0, 160) + '...' : text);
    }
  }

  goToArticle(news: NewsModel) {
    const myurl = '/public-news?id=' + news.id;
    this.router.navigateByUrl(myurl);
  }

  goToSlide(slide) {
    this.host.select(slide);
  }

  onSlide(slideEvent: NgbSlideEvent) {
    this.activeSlide = this.store.news
      .filter(news => news.visibility == 2 || news.visibility == 3)[slideEvent.current];
  }
}
